export default __webpack_public_path__ + "static/media/bx_bxs-user.9b1c1579.svg";